import { render, staticRenderFns } from "./WebSettingPage.vue?vue&type=template&id=5990bb5c&scoped=true&"
import script from "./WebSettingPage.vue?vue&type=script&lang=js&"
export * from "./WebSettingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5990bb5c",
  null
  
)

export default component.exports